import { render, staticRenderFns } from "./testemapa.vue?vue&type=template&id=f659b6a6&scoped=true"
import script from "./testemapa.vue?vue&type=script&lang=js"
export * from "./testemapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f659b6a6",
  null
  
)

export default component.exports